import * as WebFont from 'utils/webfontloader';
import { FONT_COPY, FONT_COPY_CSS, FONT_TITLE, FONT_COLOUR_LEVEL_WIN, FONT_COLOUR_STROKE } from '../constants/AppConstants';
import { createTextField } from 'utils/Text';

import LoadBar from 'app/display/ui/LoadBar';

import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';

class Load extends Phaser.State {
  preload(game) {
    this.container = game.add.group();

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 1, blockInput: false });
    this.background.anchor.set(0.5);
    this.container.add(this.background);

    this.loadComplete = false;

    this.fontsReady = false;
    this.assetsReady = false;

    this.state = 0;

    WebFont.load({
      custom: {
        families: [FONT_COPY],
        urls: [game.urls.getFontsDirectory(FONT_COPY_CSS)],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });

    game.load.baseURL = game.urls.getAssetsDirectory();
    game.load.crossOrigin = 'anonymous';
    game.load.pack('load', 'assetpack.json', null, this);
    game.load.pack('audio', 'assetpack_audio.json', null, this);
    if (game.device.ie || game.deviceController.isOldAppleDevice()) {
      game.load.pack('audioIE', 'assetpack_audio.json', null, this);
    } else {
      game.load.pack('sprites_64', 'assetpack_audio.json', null, this);
    }

    // load spine files
    this.game.load.spine('appleWalks', 'characters/Apple_Walks.json');
    this.game.load.spine('appleSelect', 'characters/AppleCselect.json');
    this.game.load.spine('onionWalks', 'characters/Onion_Walks.json');
    this.game.load.spine('onionSelect', 'characters/OnionCselect.json');
    this.game.load.spine('patty', 'characters/MsPatty.json');
    this.game.load.spine('trolleyDashers', 'levels/TrolleyDashers.json');
    this.game.load.spine('trolley', 'levels/Trolley.json');

    // create loading assets
    this.panel = this.game.make.group();
    this.panel.position.set(this.game.defaultWidth * 0.5, this.game.defaultHeight * 0.5);
    this.container.addChild(this.panel);

    this.loadBar = new LoadBar(this.game);
    this.loadBar.position.set(0, this.game.defaultHeight * 0.25);
    this.panel.add(this.loadBar);

    this.loadImage = this.game.make.sprite(0, 0, 'loader', 'cn_preloader_bg.jpg');
    this.loadImage.anchor.set(0.5);
    this.loadImage.position.set(0, -this.game.defaultHeight * 0.15);
    this.panel.add(this.loadImage);

    //
    this.positionContainer();
    game.windowEventController.handleWindowResize();
    game.scale.onSizeChange.add(this.positionContainer, this);
  }

  positionContainer() {
    const x = (this.game.width - this.game.defaultWidth) * 0.5;
    const y = (this.game.height - this.game.defaultHeight) * 0.5;

    this.background.scale.set(Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth));
    this.background.x = -(this.game.width - this.game.defaultWidth) * 0.5;

    let sx = this.game.width / this.game.defaultWidth;
    let scale = Math.min(1, sx);
    this.panel.scale.set(scale);

    this.container.position.set(x, y);
  }

  loadUpdate(game) {
    this.loadBar.update();
    this.loadBar.setProgress(this.game.load.progress / 100);
  }

  create(game) {
    this.assetsReady = true;
    this.game.sounds.touchLock();
    //this.checkLoading();
  }

  fontsLoaded() {
    this.fontsReady = true;
    this.checkLoading();
  }

  update(game) {
    this.checkLoading(game);
  }

  checkLoading(game) {
    if (!this.loadComplete && this.assetsReady && this.fontsReady) {
      const config = this.game.cache.getJSON('app_config');
      if (config) {
        this.loadBar.setProgress(1);
        this.game.controller.init({ config });
        this.game.controller.showWelcomeScreen();
        this.loadComplete = true;
      }
    }
  }

  shutdown(game) {
    game.scale.onSizeChange.remove(this.positionContainer, this);

    // destroy
    // this.background.destroy(true);
    this.container.destroy(true);

    // clear up
    // this.background = null;
    this.container = null;
  }
}

export default Load;
